import { Section } from '@globaleris/ui.library'
import moment, { isDate } from 'moment'
import { EnumEstadoViajeOpLogistica } from '../../api/oData/enums/enumEstadoViajeOpLogistica'
import { enumKeyToValue } from '../../helpers'
import { getGasDay } from '../../helpers/gasDayHelper'
import { missingFieldsForm } from '../../helpers/validateFormHelper'
import i18n from '../../i18n'
import { DataTableActionConfiguration, ActionIcons, UserRoles } from '../../model'
import { notifyError } from '../../redux'
import { CarrierTableModel, DestinationTableModel, TankModel } from './tanks.model'
import { hasRole } from '../../helpers/permissionsHelper'
import { isFulfilled } from '@reduxjs/toolkit'

export const isDatePast = (date: Date) => {
  return moment(date).isBefore(getGasDay(), 'day')
}

export const isStatePending = (state?: EnumEstadoViajeOpLogistica) => {
  return state
    ? state === EnumEstadoViajeOpLogistica.Pendiente ||
        state === EnumEstadoViajeOpLogistica.PendienteAnulacion
    : false
}

export const checkFormData = (
  formData: any,
  formDefinition: Section[],
  carriers: CarrierTableModel[] | undefined,
  destinations: DestinationTableModel[] | undefined
): boolean => {
  let isValid = true

  if (isValid && missingFieldsForm(formDefinition, formData)) {
    notifyError(i18n.t('tanks:notifications.error.errorInvalidForm'))
    isValid = false
  }
  
  if (!hasRole(UserRoles.TANKS_REPSOL_GESTIONADO) && (isValid && (carriers === undefined || carriers.length === 0))) {
    notifyError(i18n.t('tanks:notifications.error.missingCarrier'))
    isValid = false
  }

  if (!hasRole(UserRoles.TANKS_REPSOL_GESTIONADO) && (isValid && carriers && !carriers.some(c => c.lgmaster))) {
    notifyError(i18n.t('tanks:notifications.error.missingMainCarrier'))
    isValid = false
  }

  if (isValid && (destinations === undefined || destinations.length === 0)) {
    notifyError(i18n.t('tanks:notifications.error.missingDestination'))
    isValid = false
  }
  
  return isValid
}

export const checkDestinations = (destinations: DestinationTableModel[]) => {
  let total = 0
  for (let i = 0; i < destinations.length; i++) {
    const percentage = destinations[i].percentage
    total += percentage
  }
  return total !== 100 ? false : true
}

export const filterApplicableActionsConfiguration = (
  item: TankModel,
  configurations: Array<DataTableActionConfiguration>
): Array<DataTableActionConfiguration> => {
  let applicableActionsConfiguration: Array<DataTableActionConfiguration> = []
  configurations.forEach(configuration => {
    switch (configuration.icon) {
      case ActionIcons.WARNING: {
        if (item.tripState === EnumEstadoViajeOpLogistica.Rechazado) {
          applicableActionsConfiguration.push(configuration)
        }
        break
      }
      //   case ActionIcons.ERROR: {
      //     if (
      //       ((item.sendQuantity && item.quantity !== item.sendQuantity) ||
      //         (item.sendQuantityTSO && item.quantity !== item.sendQuantityTSO)) &&
      //       item.state === EnumOperationState.Enviada
      //     ) {
      //       applicableActionsConfiguration.push(configuration);
      //     }
      //     break;
      //   }
      //   case ActionIcons.FLANGES: {
      //     if (item.flanges && item.flanges.length > 0) {
      //       applicableActionsConfiguration.push(configuration);
      //     }
      //     break;
      //   }
    }
  })

  return applicableActionsConfiguration
}

export const getGlobalActionsConfiguration = (): Array<DataTableActionConfiguration> => {
  return [getStateWarningAction()]
}

const getStateWarningAction = (): DataTableActionConfiguration => {
  return {
    icon: ActionIcons.WARNING,
    // tooltip: i18n.t('regulatoryReports:dataTable.tooltips.loading'),
    tooltip: 'prueba'
  }
}

export const canOnlyView = (state: EnumEstadoViajeOpLogistica, tripDate: Date): boolean => {
  const editAllowed = canEdit(state, tripDate)
  if (editAllowed) {
    return false
  }

  return tripDate !== undefined && isDatePast(tripDate) 
          || (hasRole(UserRoles.TANKS_REPSOL_GESTIONADO) || hasRole(UserRoles.TANKS_REPSOL_NO_GESTIONADO))
          || state === EnumEstadoViajeOpLogistica.PendienteAnulacion
}

export const canEdit = (state: EnumEstadoViajeOpLogistica, tripDate: Date | undefined): boolean => {
  var editable = false;
  //55528 - Para gestionados y no gestionados solo se puede editar en estado registrado
  if (hasRole(UserRoles.TANKS_REPSOL_GESTIONADO) || hasRole(UserRoles.TANKS_REPSOL_NO_GESTIONADO)) {
    editable = state === EnumEstadoViajeOpLogistica.Registrado
  } else {
    editable = (state === EnumEstadoViajeOpLogistica.Registrado ||
      state === EnumEstadoViajeOpLogistica.Viable ||
      state === EnumEstadoViajeOpLogistica.NoViable ||
      state === EnumEstadoViajeOpLogistica.Rechazado ||
      state === EnumEstadoViajeOpLogistica.Programado ||
      state === EnumEstadoViajeOpLogistica.Pendiente ||
      state === EnumEstadoViajeOpLogistica.Validado) 
  }  

  return (editable && tripDate !== undefined && !isDatePast(tripDate))
}

export const canEditQuantity = (
  state: EnumEstadoViajeOpLogistica,
  tripDate: Date | undefined
): boolean => {
  return (
  !hasRole(UserRoles.TANKS_REPSOL_GESTIONADO) &&
  !hasRole(UserRoles.TANKS_REPSOL_NO_GESTIONADO) &&
  tripDate !== undefined && 
  isDatePast(tripDate) && !canDelete(state))
}

export const canSend = (state: EnumEstadoViajeOpLogistica): boolean => {
  return (
    !hasRole(UserRoles.TANKS_REPSOL_GESTIONADO) &&
    !hasRole(UserRoles.TANKS_REPSOL_NO_GESTIONADO) &&
    (state === EnumEstadoViajeOpLogistica.Registrado ||
    state === EnumEstadoViajeOpLogistica.Pendiente ||
    state === EnumEstadoViajeOpLogistica.Programado ||
    state === EnumEstadoViajeOpLogistica.PendienteAnulacion ||
    state === EnumEstadoViajeOpLogistica.Rechazado ||
    state === EnumEstadoViajeOpLogistica.RechazadoAnulado ||
    state === EnumEstadoViajeOpLogistica.NoViable ||
    state === EnumEstadoViajeOpLogistica.Validado)
  )
}

export const canDelete = (state: EnumEstadoViajeOpLogistica): boolean => {
  //55528 - Para gestionados y no gestionados solo se puede eliminar en estado registrado
  if (hasRole(UserRoles.TANKS_REPSOL_GESTIONADO) || hasRole(UserRoles.TANKS_REPSOL_NO_GESTIONADO)) {
    return state === EnumEstadoViajeOpLogistica.Registrado
  } else {
    return state === EnumEstadoViajeOpLogistica.Registrado ||
              state === EnumEstadoViajeOpLogistica.Anulado ||
              state === EnumEstadoViajeOpLogistica.Rechazado ||
              state === EnumEstadoViajeOpLogistica.Validado
  }
}

export const canCancel = (state: EnumEstadoViajeOpLogistica, tripDate: Date): boolean => {
  const isPast = isDatePast(tripDate)

  return isPast
    ? false
    : state === EnumEstadoViajeOpLogistica.Rechazado ||
        state === EnumEstadoViajeOpLogistica.Programado ||
        state === EnumEstadoViajeOpLogistica.Viable ||
        state === EnumEstadoViajeOpLogistica.NoViable
}

export const canCancelMassive = (rows: any[]): boolean => {
  return rows.every(row => {
    const isPast =
      row.tripDate !== undefined && moment(row.tripDate).endOf('day').toDate() < getGasDay()
    return isPast
      ? false
      : row.tripState === EnumEstadoViajeOpLogistica.Rechazado ||
          row.tripState === EnumEstadoViajeOpLogistica.Programado ||
          row.tripState === EnumEstadoViajeOpLogistica.Viable ||
          row.tripState === EnumEstadoViajeOpLogistica.NoViable
  })
}
